import { createAsyncThunk } from "@reduxjs/toolkit"
import { post, put, get } from "helpers/api_helper"
import {
  FETCH_POS_BRANCHES,
  FETCH_POS_DISCOUNTS,
  GET_POS_BRANCH_DETAILS,
  GET_POS_COUNTRY_LISTS,
  POS_MENU_SYNC,
  SYNC_POS_BRANCH,
  UPDATE_API_KEY,
} from "helpers/url_helper"

export const getPosCountryLists = createAsyncThunk(
  GET_POS_COUNTRY_LISTS,
  async payload => {
    const response = await post(GET_POS_COUNTRY_LISTS, payload)
    return response
  }
)

export const updateApiKey = createAsyncThunk(UPDATE_API_KEY, async payload => {
  const response = await post(UPDATE_API_KEY, payload)
  return response
})

export const syncMenu = createAsyncThunk(POS_MENU_SYNC, async payload => {
  const response = await post(POS_MENU_SYNC, payload)
  return response
})

export const getPosDiscounts = createAsyncThunk(
  FETCH_POS_DISCOUNTS,
  async payload => {
    const response = await post(FETCH_POS_DISCOUNTS, payload)
    return response
  }
)

export const getPosBranches = createAsyncThunk(
  FETCH_POS_BRANCHES,
  async payload => {
    const response = await post(FETCH_POS_BRANCHES, payload)
    return response
  }
)

export const syncPosBranch = createAsyncThunk(
  SYNC_POS_BRANCH,
  async payload => {
    const response = await post(SYNC_POS_BRANCH, payload)
    return response
  }
)

export const getPosBranchDetails = createAsyncThunk(
  GET_POS_BRANCH_DETAILS,
  async id => {
    const response = await get(`${GET_POS_BRANCH_DETAILS}${id}`)
    return response
  }
)
